export default function CtaBand() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-16">
        <div className="relative overflow-hidden rounded-lg">
          <div className="absolute inset-0 h-full w-full">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20cinematic%20background%20of%20film%20reels%20and%20warm%20amber%20light%20streaks%20across%20a%20dark%20velvet%20surface%2C%20crimson%20and%20gold%20accents%2C%20soft%20glow%2C%20artistic%20textured%20composition%2C%20no%20text&width=1600&height=700&seq=cta-band-01&orientation=landscape"
              alt=""
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/70 to-foreground-950/50" />
          <div className="relative flex flex-col gap-5 px-6 py-12 md:px-12 md:py-16 lg:max-w-2xl">
            <span className="inline-flex w-fit items-center gap-2 rounded-full bg-background-50/15 px-3 py-1 text-xs font-medium text-background-100">
              <i className="ri-movie-2-line"></i>
              片库持续更新中
            </span>
            <h2 className="font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
              现在就去片库，找到今天想看的那一部
            </h2>
            <p className="text-sm leading-relaxed text-background-200 md:text-base">
              电影大全、电视剧、最新电影与免费电影都在同一个片库里，按类型或关键词筛选，几步就能开始你的观影时间。
            </p>
            <div className="flex flex-col gap-3 sm:flex-row">
              <a
                href="#library"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-compass-3-line text-lg"></i>
                进入片库检索
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-trophy-line text-lg"></i>
                查看口碑榜单
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}